import { Link, useNavigate } from "react-router-dom";
import "../creator/creator.css";
import styled from "styled-components";
import Button from "../Button";
import { useState } from "react";
import { BuyArtModal } from "../modals/Modals";
import { useUser } from "../../hooks/useUser";
import { toast } from "sonner";
import { updateArt, updateUser } from "../../lib/actions";
import { getMediaElement } from "../GetMediaElement";

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  //   width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    // text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    font-size: 24px;
  }
  .text-tiny {
    font-size: 18px;
  }
  .text-3 {
    color: red;
  }
  .text-4 {
    color: red !important;
    font-size: 16px !important;
  }
  .small {
    font-size: 36px;
  }
  .smaller {
    font-size: 24px;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: flex-start;
  }
  @media (max-width: 40em) {
    // width: 90%;
  }
`;

export const BuyModal = ({ mintedArts }) => {
  const [isBuying, setIsBuying] = useState(false);
  const { data } = useUser();
  const navigate = useNavigate();
  const handleBuyModal = () => {
    setIsBuying(true);
  };

  const handleBuy = async (art) => {
    // If balance is insufficient, show an error message
    if (data.balance < art.price) {
      toast.error("Insufficient balance to buy this art.");
      setIsBuying(false);
      return;
    }

    if (data.$id === art.userId.$id) {
      toast.error("You can't purchase your own art.");
      setIsBuying(false);
      return;
    }

    try {
      // Update the Sellers balance
      await updateUser(art.userId.$id, {
        balance: art.userId.balance + art.price,
      });

      // transfer art to the buyer from the seller
      await updateArt(art.$id, { userId: data.$id });

      // Deduct the art price from the buyer's balance
      await updateUser(data.$id, {
        balance: data.balance - art.price,
      });

      toast.success("Art purchased successfully!");
      navigate("/dashboard");
      return;
    } catch (error) {
      console.log(error);
      toast.error("Error purchasing art. Please try again.");
    } finally {
      setIsBuying(false);
    }
  };

  return (
    <div className="artWrapper">
      <Title>
        <span className="text-2">Minted</span>
      </Title>
      <div className="artGrid">
        {mintedArts.map((art, index) => (
          <>
            <div className="artCard" key={index}>
              <div
                style={{
                  width: "100%",
                  aspectRatio: "1 / 1",
                  overflow: "hidden",
                  borderRadius: "0.5rem 0.5rem 0 0",
                  background: "#0f0f0f",
                  position: "relative",
                }}
              >
                {getMediaElement(art)}
              </div>
              <div className="artDetails">
                <h4>{art.name}</h4>
                <p>{art.description}</p>
                <p className="text-tiny">Price: {art.price} ETH</p>
                {art.royalty && <p className="text-tiny">Royalty: {art.royalty} %</p>}
                <Link
                  to=""
                  onClick={() => {
                    handleBuyModal();
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button className="mintButton" text={"BUY"} />
                </Link>
              </div>
            </div>

            {isBuying && art && (
              <BuyArtModal
                art={art}
                onClose={() => setIsBuying(false)}
                onBuy={handleBuy}
              />
            )}
          </>
        ))}
      </div>
    </div>
  );
};
